import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { QueueCustomerOverviewResponse } from '../../../../../hooks';
import { Icons } from '../../../../../stories/atoms';
import { areaOverviewTranslations } from '../../../../../translations/areaOverview';
import { OverviewWidget } from '../../../../areaOverview/overviewWidget/OverviewWidget';
import { AreaWidgetType } from '../../../../areaOverview/util';

type QueueCustomerOverviewWidgetProps = {
  data: QueueCustomerOverviewResponse | null;
  isLoading: boolean;
  isError: boolean;
  errorRetryHandler: () => void;
};

export const QueueCustomerOverviewWidget: FC<QueueCustomerOverviewWidgetProps> = observer(
  ({ data, isLoading, isError, errorRetryHandler }) => {
    const { t } = useTranslation();

    return (
      <OverviewWidget
        id={AreaWidgetType.QueueCustomerOverview}
        isLoading={isLoading}
        isError={isError}
        errorRetryHandler={errorRetryHandler}
        title={t(
          areaOverviewTranslations.queueCustomerOverview.title.key,
          areaOverviewTranslations.queueCustomerOverview.title.defaultValue,
        )}
        headerIcon={Icons.PROFILE}
        headerText={t(
          areaOverviewTranslations.queueCustomerOverview.headerText.key,
          areaOverviewTranslations.queueCustomerOverview.headerText.defaultValue,
        )}
        headerValue={(data?.overallQueueLength.toFixed(2) ?? 0) + '%'}
        widgetText={t(
          areaOverviewTranslations.queueCustomerOverview.widgetText.key,
          areaOverviewTranslations.queueCustomerOverview.widgetText.defaultValue,
        )}
        statistics={[
          {
            label: t(
              areaOverviewTranslations.queueCustomerOverview.customerSatisfactionText.key,
              areaOverviewTranslations.queueCustomerOverview.customerSatisfactionText.defaultValue,
            ),
            value: data?.customerSatisfaction.toFixed(2) ?? '0',
          },
          {
            label: t(
              areaOverviewTranslations.queueCustomerOverview.customerEngagementText.key,
              areaOverviewTranslations.queueCustomerOverview.customerEngagementText.defaultValue,
            ),
            value: `${data?.customerEngagement.toFixed(2) ?? '0'} (${Math.round(
              data?.customerEngagementCount ?? 0,
            )})`,
          },
        ]}
      />
    );
  },
);
